module.exports = __webpack_public_path__ + "static/media/feliz.1756be35.jpeg";